import { useContext } from "react";

import { NavigatorContext } from "./NavigatorContext";

export const useNavigatorContext = () => {
  const ctx = useContext(NavigatorContext);
  if (!ctx)
    throw new Error(
      "useNavigatorContext must be used within NavigatorProvider"
    );
  return ctx;
};
